'use client';
import clsx from 'clsx';
import dynamic from 'next/dynamic';
import { useDropdownContext } from '../../../components/DropdownProvider';
import { CLOSE_NOTIFICATIONS_ACTION } from '../../../components/DropdownProvider/useSingleDropdown';
import { FullscreenOverlay } from '../../../components/FullscreenOverlay';
import { useBodyScrollLock } from '../../../hooks/useBodyScrollLock';
import { useIsMounted } from '../../../hooks/useIsMounted';
import { useSatelliteContext } from '../../SatelliteProvider';
import { userHasIdToken } from '../utils';
import { NotificationsBell } from './NotificationBell';

const NotificationSidebar = dynamic(
  () => import('./NotificationSidebar').then(module => module.NotificationsSidebar),
  { ssr: false },
);

export function NotificationCenter() {
  const {
    headerOptions: { enableAuthButtons },
  } = useSatelliteContext();

  const mounted = useIsMounted();

  const { state, dispatch } = useDropdownContext();
  useBodyScrollLock(state.isNotificationSidebarOpen);

  const showBellButton = enableAuthButtons && userHasIdToken();

  if (!showBellButton || !mounted) {
    return null;
  }

  return (
    <div
      className={clsx(
        'flex',
        'items-center',
        'justify-center',
        'bg-transparent',
        'border-0',
        'focus:outline-2',
        'focus:outline-offset-4',
      )}
    >
      <NotificationsBell />
      <FullscreenOverlay
        isOpen={state.isNotificationSidebarOpen}
        onClick={() => {
          dispatch(CLOSE_NOTIFICATIONS_ACTION);
        }}
      />
      {state.isNotificationSidebarOpen && <NotificationSidebar />}
    </div>
  );
}
